import { useState } from "react";
import type { Staff } from "@/api/admin";
import type { AdminClient } from "@/api/client";
import { CodeStep } from "./code-step";
import { EmailStep } from "./email-step";
import { PublicFrame } from "./public-frame";

type Step = { kind: "email" } | { kind: "code"; email: string };

/**
 * Staff sign-in for one brand (section 8, the AnyTV provider console's sign-in): the work email,
 * then the six digit code from the mail; a passkey replaces both. Sessions are per brand.
 */
export function SignIn({ client, onSignedIn }: { client: AdminClient; onSignedIn: (staff: Staff) => void }) {
  const [step, setStep] = useState<Step>({ kind: "email" });
  const [email, setEmail] = useState("");
  if (step.kind === "code") {
    return (
      <PublicFrame brand={client.brand} title="Check your mail" description="Enter the code we sent you.">
        <CodeStep client={client} email={step.email} onSignedIn={onSignedIn} onChangeEmail={() => setStep({ kind: "email" })} />
      </PublicFrame>
    );
  }
  return (
    <PublicFrame brand={client.brand} title="Welcome back" description={`Sign in to the ${client.brand.name} Studio Console with a code from your mail.`}>
      <EmailStep client={client} initialEmail={email} onSignedIn={onSignedIn} onCodeSent={(sent) => { setEmail(sent); setStep({ kind: "code", email: sent }); }} />
    </PublicFrame>
  );
}
